import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[numberFocus]',
    standalone: false
})
export class NumberFocusDirective
{

  @HostListener('focus', ['$event'])
  public trackFocusEvent($event)
  {
    const target = $event.target;

    target.selectionStart = 0;
    target.selectionEnd = target.value.length;
  }
}
